<script>
import GmapMarker from 'gmap-vue/dist/esm/components/marker-icon.vue'
import GmapMap from 'gmap-vue/dist/esm/components/map-layer.vue'
import mapOptions from '@/modules/mixins/mapOptions'
export default {
    name: 'AddressBlock',
    components: { GmapMarker, GmapMap },
    mixins: [mapOptions],
    props: {
        model: null,
    },
    computed: {
        addressSelected() {
            return this.$store.getters['order/address']?.id === this.model?.id
        },
        isWorkAddress() {
            return this.model?.is_company_address
        },
        addressBlockMapOptoins() {
            return {
                ...this.mapOptions,
                ...{
                    minZoom: 16,
                    maxZoom: 16,
                    zoom: 16,
                    gestureHandling: 'none',
                    keyboardShortcuts: false,
                },
            }
        },
    },
    methods: {
        edit() {
            this.$location.edit.open(this.model)
        },
        orderHere() {
            if (this.addressSelected) this.$router.push({ name: 'restaurant-list' })
            else
                this.$store.dispatch('order/setAddress', this.model).then(() => {
                    this.$router.push({ name: 'restaurant-list' })
                })
        },
    },
}
</script>

<template lang="pug">
.card(v-if="model && model.name")
    .overflow-hidden
        gmap-map.h-fix-150(:options="addressBlockMapOptoins" :center="{lat: model.latitude, lng:model.longitude}")
            gmap-marker(:position="{lat: model.latitude, lng:model.longitude}" :options="{cursor: 'default'}" icon="/images/marker-dropoff.svg")        
    .card-body.position-relative.d-flex.flex-column        
        button.position-absolute.z-1.btn.btn-white-primary.btn-pill.shadow-5.top--fix-20.right-fix-20(@click="edit")
            icon.mr-2(icon="fa-solid fa-pencil-alt")
            | {{ $t('base.edit') }}
        h4.d-flex.align-items-center
            icon.mr-2(:icon="`fa-solid ${isWorkAddress ? 'fa-briefcase' : 'fa-location-arrow'}`" :key="`addressIcon-${isWorkAddress}-${_uid}`")
            span.text-ellipsis-2.font-weight-semibold(v-if="model.name") {{model.name}}
        p.text-73.body-m.mb-2(v-if="model.full_address") {{model.full_address}}
            template(v-if="model.sub_address") , {{model.sub_address}}
        p.d-flex.align-items-center.text-73.body-m.mb-2(v-if="model.phone")
            icon.mr-2(icon="fa-solid fa-phone")
            | {{model.phone}}
        p.d-flex.align-items-baseline.text-73.body-m.mb-2(v-if="model.comment")
            icon.mr-2.relative.top-fix-3(icon="fa-solid fa-comment")
            span.text-ellipsis {{model.comment}}
        button.btn.btn-primary.btn-xs.ml-auto.mt-auto(@click="orderHere") {{ $t('profile.order_here') }}



</template>
